export const AlertIcon = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4C7.58867 4 4 7.58867 4 12C4 16.4113 7.58867 20 12 20C16.4113 20 20 16.4113 20 12C20 7.58867 16.4113 4 12 4ZM12.6667 15.3333C12.6667 15.702 12.368 16 12 16C11.632 16 11.3333 15.702 11.3333 15.3333V11.3333C11.3333 10.9647 11.632 10.6667 12 10.6667C12.368 10.6667 12.6667 10.9647 12.6667 11.3333V15.3333ZM12 9.33333C11.54 9.33333 11.1667 8.96 11.1667 8.5C11.1667 8.04 11.54 7.66667 12 7.66667C12.46 7.66667 12.8333 8.04 12.8333 8.5C12.8333 8.96 12.46 9.33333 12 9.33333Z" fill="#9E3F00"/>
      </svg>
    );
  };
